window.stimulusApp.register(
  "pin",
  class extends Stimulus.Controller {
    static outlets = ["new-pin"]
    static targets = [
      "field",
      "fieldContainer",
      "fullPinCodeField",
      "pinCodeTimeoutField",
      "alert",
    ]

    #errorCSSClass = "field-container_soft-error"
    #metaKey = false
    #pin = null

    connect() {
      if (HB.isDesktop && !this.hasAlertTarget) {
        this.fieldTargets[0].focus()
      }
    }

    focus() {
      if (this.hasAlertTarget) {
        this.alertTarget.remove()
        this.fieldContainerTarget.classList.remove(this.#errorCSSClass)
      }

      this.firstEmptyField?.focus()
    }

    keydown(event) {
      let key = event.key

      // Capture paste combination
      if (key == "Meta" || key == "Control") {
        this.#metaKey = true
      }

      if (this.#isNotValidKey(event)) {
        event.preventDefault()
      }

      if (key == "Backspace" && event.target != this.fieldTargets[0]) {
        event.preventDefault()
        this.#cleanUpPreviousField()
        return
      }
    }

    // Special event for virtual keyboard suggestions
    textInput(event) {
      if (event.data.length > 1) {
        this.pin = event.data
        this.#insert()
      }
    }

    input() {
      this.#metaKey = false
      this.focus()
      this.fullPinCodeFieldTarget.value = this.fieldTargets
        .map(this.#isPresent)
        .join("")

      if (!this.firstEmptyField) {
        this.pinCodeTimeoutFieldTarget.value = this.newPinOutlet.timeoutValue
        this.element.requestSubmit()
      }
    }

    paste(event) {
      this.pin = (event.clipboardData || window.clipboardData).getData("text")
      this.#insert()
    }

    set pin(raw) {
      this.#pin = raw.split("").map(Number).filter(Number.isInteger).slice(0, 6)
    }

    get firstEmptyField() {
      return this.fieldTargets.filter(this.#isEmpty)[0]
    }

    get lastFilledField() {
      return (
        this.fieldTargets.filter(this.#isPresent).at(-1) || this.fieldTargets[0]
      )
    }

    #insert() {
      this.#pin.forEach((val, idx) => {
        let field = this.fieldTargets[idx]
        field.value = val
        field.dispatchEvent(new Event("input"))
      })
    }

    #cleanUpPreviousField() {
      this.lastFilledField.value = null
      this.lastFilledField.focus()
    }

    #isNotValidKey(event) {
      return isNaN(event.key) && !(this.#metaKey && event.keyCode == 86)
    }

    #isPresent(el) {
      return el.value
    }

    #isEmpty(el) {
      return !el.value
    }
  },
)
